import React, { useContext, useState } from 'react';
import LogoLight from '@images/logoLight.svg';
import SideBar from '@/components/SideBar';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useNavigate } from 'react-router-dom';
import { AlignJustify } from 'lucide-react';
import { useUserStore } from '@/stores/user';
import { capitalizeFirstLetter, stringToHexColor } from '@/lib/utils';
import { NavigationBlockerContext } from '@/context/NavigationBlockerContext';
import AlertBox from './AlertBox';

const NavBar: React.FC = () => {
  const { setIsDirty, isDirty } = useContext(NavigationBlockerContext);
  const [showAlertPath, setShowAlertPath] = useState<string | undefined>(undefined);
  const userStore = useUserStore((state) => state);
  const navigate = useNavigate();

  const handleLogout = () => {
    setIsDirty(false);
    userStore.reset();
    userStore.setInactivityTimeout(false);
    navigate('/login');
  };
  return (
    <>
      <div className="w-full bg-primary flex items-center justify-between md:px-8 px-3 py-3 fixed z-0">
        <div>
          <img src={LogoLight} alt="logo" className="h-[50px] w-[160px]" />
        </div>

        {/* <div className="md:flex w-auto justify-center items-center hidden">
        <SearchBar />
      </div> */}

        {userStore.user && (
          <div className=" flex-row gap-3 items-center w-auto hidden md:flex">
            <div className="flex flex-col text-[16px] justify-end items-end">
              <div className="text-white font-medium text-4">{userStore.user?.firstName}</div>
              <div className="flex text-[#969696] justify-end text-sm ">
                {userStore.user?.roleId && capitalizeFirstLetter(userStore.user?.roleId)}
              </div>
            </div>
            <div>
              <DropdownMenu>
                <DropdownMenuTrigger className="focus:outline-none focus-visible:outline-none">
                  <div
                    className={`rounded-full w-[48px] h-[48px] text-xl hover:bg-[#D72222] focus:outline-none focus-visible:outline-none text-white p-2.5`}
                    style={{ background: stringToHexColor(userStore.user?.firstName) }}
                  >
                    {userStore.user?.firstName?.charAt(0)}
                  </div>
                </DropdownMenuTrigger>
                <DropdownMenuContent className=" mr-5 mt-3">
                  <DropdownMenuLabel>My Account</DropdownMenuLabel>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem
                    onClick={() => {
                      if (!isDirty) {
                        setIsDirty(false);
                        navigate('/profile');
                      } else {
                        setShowAlertPath('/profile');
                      }
                    }}
                  >
                    Profile
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    onClick={() => {
                      if (!isDirty) {
                        handleLogout();
                      } else {
                        setShowAlertPath('/login');
                      }
                    }}
                  >
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        )}
        <div className="flex md:hidden ">
          <Sheet>
            <SheetTrigger>
              <AlignJustify size={22} color="#fff" />
            </SheetTrigger>
            <SheetContent className="md:hidden flex flex-col w-[60vw] bg-primary">
              <SheetHeader>
                <SheetTitle className="text-white">{userStore.user?.firstName}</SheetTitle>
                <SheetDescription className="text-white">
                  {userStore.user?.roleId &&
                    userStore.user?.roleId.charAt(0).toUpperCase() + userStore.user?.roleId.slice(1).toLowerCase()}
                </SheetDescription>
              </SheetHeader>

              <div className="w-full">
                <SideBar />
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
      {showAlertPath && (
        <AlertBox
          open={true}
          description="Changes which you made might not be saved."
          title="Are you sure?"
          confirmBtnClick={() => {
            if (showAlertPath === '/login') {
              handleLogout();
            } else {
              setShowAlertPath(undefined);
              navigate(showAlertPath);
              setIsDirty(false);
            }
          }}
          cancelBtnClick={() => setShowAlertPath(undefined)}
          confirmBtnLabel="Yes"
          cancelBtnLabel="No"
        />
      )}
    </>
  );
};

export default NavBar;
